import Header from "../../components/Header";
import { Box, Typography, Container } from "@mui/material";
import Predios from "../../assets/predios.jpg";
import UserImage from "../../assets/logo.png";
import Form from "../../components/FormResidencial";
import Footer from "../../components/Footer";

const HeroSection = () => {
  return (
    <div
    style={{
      backgroundColor: '#f0f0f0',
      margin: -8,
      position: 'relative',
      width: '102%',
      overflowX: 'hidden',
    }}
  >
      <Header />
      <Box
        sx={{
          marginTop: "-20px",
          position: "relative",
          height: "50vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#f0f0f0",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${Predios})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <Container>
          <Typography
            variant="h2"
            fontWeight={700}
            sx={{
              fontFamily: "Playfair Display, serif",
              color: "transparent",
              WebkitTextStroke: "2px white",
            }}
          >
            Bem vindo
          </Typography>
          <Typography variant="h5" mt={2} sx={{ fontFamily: "Merriweather, serif", color: "white" }}>
            Vamos iniciar cotação e contratação do seu Seguro Residencial.
          </Typography>
        </Container>
      </Box>

      {/* Box que cobre a imagem ao rolar */}
      <Box
        sx={{
          width: "100%",
          height: "12vh", // Aumentamos a altura para acomodar o texto
          backgroundColor: "#f0f0f0",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {/* Imagem redonda centralizada */}
        <Box
          component="img"
          src={UserImage}
          alt="Ícone de usuário"
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            position: "absolute",
            top: "-40px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#f0f0f0",
            boxShadow: 3,
          }}
        />

        {/* Texto abaixo da imagem */}
        <Typography variant="subtitle1" fontWeight={600} mt={6} sx={{ fontFamily: "Merriweather, serif", color: "#1228a3" }}>
          Por favor, preencha seus dados e estipule seu valor desejado.
        </Typography>
      </Box>

      <Form />
      <Footer />
    </div>
  );
};

export default HeroSection;
